"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisibleColumns = exports.setStatusVisibleColumns = void 0;
var isVisibleColumn = function (id, columnsSetting) {
    var _a;
    return (Object.keys(columnsSetting).length ? !!((_a = columnsSetting[id]) === null || _a === void 0 ? void 0 : _a.checked) : true);
};
var getVisibleColumns = function (items) { return items
    .filter(function (_a) {
    var visible = _a.visible;
    return visible;
}); };
exports.getVisibleColumns = getVisibleColumns;
var getColumnsSettingMap = function (items) { return items
    .reduce(function (acc, item) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[item.key] = item, _a)));
}, {}); };
var setStatusVisibleColumns = function (columns, columnsSetting) {
    var columnsSettingMap = getColumnsSettingMap(columnsSetting);
    return columns
        .map(function (item) { return (__assign(__assign({}, item), { visible: isVisibleColumn(item.id, columnsSettingMap) })); });
};
exports.setStatusVisibleColumns = setStatusVisibleColumns;
